<template>
    <Card no-padding class="report-risk-card mt-3 min-h-[480px] !bg-eureka-500">
        <div class="flex min-h-[480px] flex-row">
            <div class="flex grow flex-col justify-between px-12 py-10">
                <p class="mb-5 h-6 text-base font-bold text-white">{{ $t('riskPoint') }}</p>
                <div v-for="(point, idx) in list" :key="idx" class="text-sm leading-6 text-white first-of-type:mb-5">{{point}}</div>
                <div class="mt-5 flex flex-row items-center justify-end">
                    <IconApostrophe class="ml-1 fill-white"/>
                    <IconApostrophe class="ml-1 fill-white"/>
                </div>
            </div>
            <div class="risk-point-card w-[317px] shrink-0 rounded-r-[14px] bg-cover bg-right bg-no-repeat"></div>
        </div>
    </Card>
</template>
<script setup lang="ts">
import { withDefaults, onMounted, reactive } from 'vue';
import Card from '../Card.vue'
import IconApostrophe from '../icons/IconApostrophe.vue';

const props = withDefaults(defineProps<{
    pointList: string[],
}>(), {
    pointList: () => [],
})

const list: string[] = reactive([]);

onMounted(() => {
    list.push(...props.pointList);
});
</script>
<style lang="scss">
.risk-point-card {
    background-image: url('@/assets/images/riskRight.png');
}
</style>
